import randomElement from "../randomElement";
import shuffle from "../shuffle";

function Question(minigameData, state){
    var minigametype;
    var arr_wrong;
    let variants = [];
    let variantsT = [];
    let comms = [];
    let ansScore = [];
    let arr_right;
    let qType = "standart";
    let data = randomElement(minigameData.data.questions);
    if(!data.wrong_ans && data.incorrectGen){
        data.wrong_ans = Array(10).fill(0).map(data.incorrectGen);
    }
	switch (Number(state.objects.difficulty)) {
		case 0:
            arr_wrong = data.wrong_ans;
            minigametype = 'Question';
            break;
		case 1:
            arr_wrong = (data.wrong_ans1) ? data.wrong_ans1 : data.wrong_ans; 
            minigametype = 'Question';
			break;
		default:
			throw new Error(`Difficulty '${state.objects.difficulty}' is not implemented`);
    }
    arr_right = data.correct_ans[0];
    variants = arr_wrong.concat(arr_right);
    variants = shuffle(variants);

    let specialVar = ["Ни один", "Ни одна", "Все перечисленные"];
    let border = variants.length;
    
    if(typeof(data.correct_ans[0]) === "object") {
        for(let i = 0; i < border; i++){
            if(specialVar.some(elem => variants[i].ans.includes(elem))){
                let temp = variants[i];
                qType = "special";
                variants.splice(i, 1);
                variants.push(temp);
                border = border - 1;
            }
        }
        arr_right = arr_right.ans;
        comms = variants.map(elem => elem.comm ? elem.comm : null);
        variantsT = variants.map(elem => elem.ans);
        ansScore = variants.map(elem => elem.score);
    }
    if(variantsT.some(elem => elem.length > 50)){
        qType = "big";
    }
    let form = {
        question: data.qst,
        options: variantsT,
        comms: comms,
        correct: variantsT.indexOf(arr_right),
        scores: ansScore,
        type: minigametype,
        qType: qType
    }
    return form;
};

export default Question;